import { defineComponent as _defineComponent } from 'vue';
import { renderSlot as _renderSlot, unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, mergeProps as _mergeProps, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-6e30bebc"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "flex flex-row items-center justify-between space-x-3 w-full" };
const _hoisted_2 = { class: "dropdown-button__menu" };
import { ChevronDownIcon } from "@heroicons/vue/outline";
import { ref } from "vue";
import Button from "@/components/Button.vue";
export default /*#__PURE__*/ _defineComponent({
    setup(__props) {
        const openMenu = ref(false);
        const popper = ref();
        const open = () => {
            openMenu.value = true;
        };
        const close = () => {
            openMenu.value = false;
        };
        const toggle = () => {
            openMenu.value = !openMenu.value;
        };
        return (_ctx, _cache) => {
            const _directive_click_outside = _resolveDirective("click-outside");
            return _withDirectives((_openBlock(), _createElementBlock("div", null, [
                _createVNode(Button, _mergeProps({ type: "button" }, _ctx.$attrs, { onClick: toggle }), {
                    default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_1, [
                            _renderSlot(_ctx.$slots, "default"),
                            _createVNode(_unref(ChevronDownIcon), { class: "icon" })
                        ])
                    ]),
                    _: 3
                }, 16),
                _withDirectives(_createElementVNode("div", _hoisted_2, [
                    _renderSlot(_ctx.$slots, "menu")
                ], 512), [
                    [_vShow, openMenu.value]
                ])
            ])), [
                [_directive_click_outside, close]
            ]);
        };
    }
});
